import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[bookshelfTemplateAction]',
})
export class BookshelfTemplateActionDirective {
  constructor(public template: TemplateRef<any>) {
  }
}
